export default __webpack_public_path__ + "static/2-travelling-to-fiji-guide-7c8f9201b2e3d1cbb88835c40c933d7c.jpg";